import React, { useState, useEffect, useReducer, useCallback } from 'react';

import { useParams } from 'react-router-dom';

import { Content } from '../../components/Content';

import FURGAPI from '../../services/api.furg';
import { getToken } from '../../services/auth';

import CandidatoLoader from '../../components/Candidato/CandidatoLoader';
import Recursos from '../../components/Recursos';

import { DocumentoArquivos, DocumentoCiencia, DocumentoFormulario } from '../../components/Documentos/';
import { Loading } from '../../components/Loading';

const Documentos = () => {
    const { vestibular } = useParams();
    const [info, setInfo] = useState({});
    const [temPendencias, setTemPendencias] = useState(false);
    const [loading, setLoading] = useState(true);
    const [equipesRecursos, setEquipesRecursos] = useState([]);

    const verificaPendencias = (periodo, docs) => {
        if (periodo === 'N') {
            setTemPendencias(docs.filter(doc => !doc.nr_protocolo).length > 0);
        } else if (periodo === 'R') {
            setTemPendencias(docs.filter(doc => doc.documentacao_aceita === 'N' && !doc.nr_protocolo_recurso).length > 0);
        }
    };

    const [state, dispatch] = useReducer(
        (state, action) => {
            switch (action.type) {
                case 'add':
                    const ret = { documentos: [...state.documentos, ...action.documentos] };
                    verificaPendencias(info.tp_envio_liberado, ret.documentos);
                    return ret;

                case 'update_doc':
                    const documentos = state.documentos.map(doc => {
                        if (doc.id_tipo_documento_candidato === action.id) {
                            return { ...doc, ...action.documento };
                        }
                        return doc;
                    });
                    verificaPendencias(info.tp_envio_liberado, documentos);
                    return { documentos };

                default:
                    throw new Error();
            }
        },
        { documentos: [] }
    );

    const carregarEquipesParaRecurso = useCallback(async () => {
        setLoading(true);
        const token = getToken(vestibular);
        const data = await FURGAPI.call('sischamamentos/Publico/obtemEquipesComIndeferimento', { token });
        setEquipesRecursos(data);
        setLoading(false);
    }, [vestibular]);

    useEffect(() => {
        const token = getToken(vestibular);
        setLoading(true);
        FURGAPI.call('sischamamentos/Publico/obtemDocumentosCandidato', {
            token,
        })
            .then(resposta => {
                const { documentos, ...dados } = resposta;
                setInfo(dados);

                dispatch({ type: 'add', documentos: documentos });
                setLoading(false);
            })
            .catch(err => setLoading(false));

        carregarEquipesParaRecurso();
    }, [carregarEquipesParaRecurso, vestibular]);

    return (
        <Content title="Solicitação de matrícula on-line" subtitle="Envie seus documentos para realizar sua solicitação de matrícula e comprovação das políticas de ações afirmativas ">
            {loading ? (
                <Loading />
            ) : (
                <div className="container-fluid">
                    <CandidatoLoader
                        fl_pendencias={temPendencias}
                        vestibular={vestibular}
                        podeMostrarNotificacaoDeProcessamentoDeferimento={
                            state?.documentos.length > 0 &&
                            state?.documentos.filter(doc => {
                                return doc.documentacao_aceita === undefined;
                            }).length < state?.documentos.length &&
                            state?.documentos.filter(doc => {
                                return doc.documentacao_aceita === 'N' && doc.recurso_aceito === 'N';
                            }).length === 0
                        }
                        podeMostrarNotificacaoDeProcessamentoIndeferimento={
                            state?.documentos.length > 0 &&
                            state?.documentos.filter(doc => {
                                return doc.documentacao_aceita === undefined;
                            }).length < state?.documentos.length &&
                            state?.documentos.filter(doc => {
                                return doc.documentacao_aceita === 'N' && doc.recurso_aceito === 'N';
                            }).length > 0
                        }
                    />

                    <Recursos vestibular={vestibular} equipesRecursos={equipesRecursos} />
                    {state.documentos.map(documento => {
                        if (documento.tp_campo === 'f') {
                            return (
                                <DocumentoFormulario
                                    key={documento.id_tipo_documento_candidato}
                                    id={documento.id_tipo_documento_candidato}
                                    vestibular={vestibular}
                                    descricao={documento.tx_tipo_documento}
                                    campos={documento.campos}
                                    campos_recurso={documento.campos_recurso}
                                    infoPrimeiraFase={{
                                        nr_protocolo: documento.nr_protocolo,
                                        dt_envio: documento.dt_envio,
                                        podeReenviar: 'N' === info.fase_atual,
                                        documentacao_aceita: documento.documentacao_aceita,
                                        documentacao_parecer: documento.documentacao_parecer,
                                        campos_defaultValues: documento.campos_defaultValues,
                                    }}
                                    infoRecurso={{
                                        nr_protocolo: documento.nr_protocolo_recurso,
                                        dt_envio: documento.dt_envio_recurso,
                                        podeReenviar: 'R' === info.fase_atual,
                                        documentacao_aceita: documento.recurso_aceito,
                                        documentacao_parecer: documento.recurso_parecer,
                                        campos_defaultValues: documento.campos_defaultValues_recurso,
                                    }}
                                    etapaAtual={info.fase_atual}
                                    onUpdate={(id, documento) => {
                                        dispatch({ type: 'update_doc', id, documento });
                                    }}
                                    pareceres={documento.pareceres}
                                    pareceres_recurso={documento.pareceres_recurso}
                                />
                            );
                        } else if (documento.tp_campo === 'b') {
                            return (
                                <DocumentoCiencia
                                    key={documento.id_tipo_documento_candidato}
                                    onUpdate={(id, documento) => {
                                        dispatch({ type: 'update_doc', id, documento });
                                    }}
                                    vestibular={vestibular}
                                    tipo_envio={info.tp_envio_liberado}
                                    fase={info.fase_atual}
                                    documento={documento}
                                />
                            );
                        }
                        documento.arquivos = documento?.arquivos ?? [];
                        documento.arquivos_recurso = documento?.arquivos_recurso ?? [];
                        return (
                            <DocumentoArquivos
                                key={documento.id_tipo_documento_candidato}
                                vestibular={vestibular}
                                tipo_envio={info.tp_envio_liberado}
                                {...documento}
                                onUpdate={(id, documento) => {
                                    dispatch({ type: 'update_doc', id, documento });
                                }}
                            />
                        );
                    })}
                </div>
            )}
        </Content>
    );
};
export default Documentos;
